export default __webpack_public_path__ + "static/media/hero.50f4b9d9.jpeg";